import classNames from 'classnames'
import React from 'react'

import { isHyphenatedLocale } from '../../locale/i18n'
import { renderRichTextWithHTML } from '../../logic/contentful'
import { IContentfulLargeLeadForm } from '../../logic/shared-types'
import MeasurImage from '../MeasurImage'
import { SubscriptionForm } from '../SubscriptionForm'

import './LargeLeadForm.scss'

export const LargeLeadForm = ({
  section,
  pageSlug,
}: {
  section: IContentfulLargeLeadForm
  pageSlug: string
}) => {
  const { title, body, image, contentful_id } = section

  return (
    <div className="largeLeadForm">
      <div className="largeLeadForm__body">
        <div className="largeLeadForm__column largeLeadForm__column--left">
          <h2
            className={classNames('largeLeadForm__heading', {
              hyphenate: isHyphenatedLocale(),
            })}
          >
            {title}
          </h2>
          <div className="richText">
            {renderRichTextWithHTML({ text: body })}
          </div>
        </div>
        {image?.gatsbyImageData && (
          <div className="largeLeadForm__column largeLeadForm__column--right">
            <MeasurImage
              className="largeLeadForm__image"
              image={image.gatsbyImageData}
              title={image.title}
              alt={image.title ?? `${title} preview`}
            />
          </div>
        )}
      </div>
      <SubscriptionForm
        sectionId={contentful_id}
        pageSlug={pageSlug}
        {...section}
      />
    </div>
  )
}
